(() => {
  const init = () => {
    document.querySelectorAll('.ffn-sticky-header').forEach(header => {
      if (header.ffnStickyObserver) return;
      const announcement = header.querySelector('.ffn-announcement');
      const nav = header.querySelector('.ffn-nav-inner');
      if (!announcement || !nav) return;
      const measure = () => {
        header.style.setProperty('--ffn-announcement-height', `${announcement.getBoundingClientRect().height}px`);
        document.documentElement.style.setProperty('--ffn-nav-height', `${nav.getBoundingClientRect().height + 1}px`);
      };
      measure();
      header.ffnStickyObserver = new ResizeObserver(measure);
      header.ffnStickyObserver.observe(announcement);
      header.ffnStickyObserver.observe(nav);
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    event.target.ffnStickyObserver?.disconnect();
  });
})();
